import { sunExposure } from './sunExposure';
import { termsReminder } from './termsReminder';

export const es = { sunExposure, termsReminder };
